<template>
	<datatable
		v-model:server-options="params"
		size="large"
		:total
		:rows="params.rowsPerPage"
		:headers
		:value="items"
		:loading
		clickable
		@row-click="handleRowClick">
	</datatable>
</template>

<script lang="ts" setup>
	import { watch } from 'vue'
	import type { Header, Row } from '@/data/types/datatable'
	import { useRouter } from 'vue-router'
	import { useDatatable } from '@/composables/datatable.js'

	const router = useRouter()
	const { params } = useDatatable()

	defineProps({
		items: {
			type: Array<Row>,
			default: []
		},
		total: {
			type: Number,
			default: 0
		},
		loading: {
			type: Boolean
		}
	})

	function handleRowClick(item: Row) {
		if (item && item.id) {
			router.push(`/yard-app/collection-item/${item.collection_number}`)
		}
	}

	const headers: Header[] = [
		{ value: 'collection_number', text: 'Coll No', props: { sortable: true } },
		{ value: 'account_name', text: 'Customer Name', props: { sortable: true } },
		{ value: 'collection_date', text: 'Coll Date', props: { sortable: true } },
		{ value: 'haulier', text: 'Haulier', props: { sortable: true } }
	]

	const emit = defineEmits(['paramsChanged'])

	watch(
		params,
		() => {
			emit('paramsChanged', params.value)
		},
		{ deep: true }
	)
</script>
